/**
 * 重构单列过滤旧版高级组件入口
 * */
import React from "react";
import { TableProps } from '../iTable';
import { TableInterface } from "../index";


export default function singleFilter(Table: React.ComponentClass<Partial<TableProps>> | TableInterface) {
    const SingleFilterTable: React.FC<TableProps> = (props) => {
        return <Table {...props} singleFilter={true}/>;
    };

    return SingleFilterTable as React.ComponentClass<Partial<TableProps>> | TableInterface;
}
